export default function Terms() {
    return (
        <div className="container-tight max-w-3xl py-16 lg:py-24">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
                Legal
            </p>
            <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
                Terms of Service
            </h1>
            <p className="mt-4 text-sm text-slate-500">Effective: 1 February 2026</p>

            <div className="mt-10 space-y-6 text-slate-600 dark:text-slate-400 leading-relaxed">
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        1. Service Description
                    </h2>
                    <p>
                        TenderTrackAI.com provides AI-powered tender document analysis as
                        a subscription service. All analyses are advisory in nature and
                        do not constitute legal or financial advice.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        2. Subscriptions, Payments &amp; Credits
                    </h2>
                    <p>
                        Plans renew monthly and may be cancelled at any time from your
                        dashboard. One credit equals one complete tender analysis.
                        Unused Starter credits do not roll over. All payments are
                        collected in Indian Rupees (INR) and processed securely through
                        our payment partner, Razorpay, supporting UPI, cards, net
                        banking and wallets. Current plan pricing is listed on our{" "}
                        <a href="/pricing" className="text-indigo-600 hover:underline">
                            Pricing page
                        </a>
                        .
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        3. Cancellation &amp; Refunds
                    </h2>
                    <p>
                        We offer a 7-day refund window on first purchase, provided 2 or
                        fewer analysis credits have been consumed. Full details,
                        timelines and the request process are described in our{" "}
                        <a href="/refund-policy" className="text-indigo-600 hover:underline">
                            Cancellation &amp; Refund Policy
                        </a>
                        .
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        4. Acceptable Use
                    </h2>
                    <p>
                        You agree not to upload illegal, malicious, or confidential
                        third-party data without authorization. We reserve the right to
                        suspend accounts misusing the platform.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        5. Liability
                    </h2>
                    <p>
                        TenderTrackAI is provided &ldquo;as is.&rdquo; We do not guarantee the
                        accuracy of every extracted field — always verify critical
                        information directly with the issuing authority before bidding.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        6. Governing Law
                    </h2>
                    <p>
                        These terms are governed by the laws of India. Any disputes
                        shall be subject to the exclusive jurisdiction of the courts of
                        Bengaluru, Karnataka.
                    </p>
                </section>
            </div>
        </div>
    );
}
